import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between shrink-0 md:gap-x-4 px-4 py-2 md:px-0 md:py-0 border-b-2 md:border-b-0" }
const _hoisted_2 = { class: "h-8 w-8 rounded-full bg-gray-300 flex justify-center items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "text-gray-700"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex items-center gap-x-3" }

import { computed } from "vue"
import { useRouter } from "vue-router"
import GgmsButton from "@/components/GgmsButton.vue"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue"
import {
    PhoneIcon,
    MailIcon,
    ChatAltIcon,
    UserAddIcon,
    BellIcon,
    UserIcon,
    OfficeBuildingIcon,
    LogoutIcon,
    CreditCardIcon,
    ClipboardCheckIcon,
} from "@heroicons/vue/outline"
import { useAuthStore } from "@/stores/auth"
import { useSocketStore } from "@/stores/socket"
import { useMainStore } from "@/stores/main"
import { useAgencyThemeStore } from "@/stores/agency-theme"
import { useNavigationSidebarStore } from "@/stores/navigation-sidebar"
import { User } from "@/shared/models/user"
import { clearStorage, getInitials } from "@/shared/utils/helpers"
import { setColorShades } from "@/shared/utils/color-helpers"
import { useWorkflowStore } from "@/stores/workflow"
import { useFormStore } from "@/stores/form"
import { setIsLoggingOut } from "@/shared/utils/auth-state"
import { AuthUserRole } from "@/shared/models/user"


export default /*@__PURE__*/_defineComponent({
  __name: 'MenuActionItems',
  emits: [
    "openPhoneSidebar",
    "openAddContactModal",
    "openNotificationSidebar",
    "openNewEmail",
    "openNewMessage",
    "openCreateTaskModal",
],
  setup(__props, { emit: __emit }) {

const router = useRouter()
const authStore = useAuthStore()
const socketStore = useSocketStore()
const mainStore = useMainStore()
const agencyThemeStore = useAgencyThemeStore()
const navigationSidebarStore = useNavigationSidebarStore()
const workflowStore = useWorkflowStore()
const formStore = useFormStore()

const emit = __emit

const menuActionItems = [
    {
        icon: PhoneIcon,
        onClick: () => emit("openPhoneSidebar"),
    },
    {
        icon: MailIcon,
        onClick: () => emit("openNewEmail"),
    },
    {
        icon: ChatAltIcon,
        onClick: () => emit("openNewMessage"),
    },
    {
        icon: UserAddIcon,
        onClick: () => emit("openAddContactModal"),
    },
    {
        icon: ClipboardCheckIcon,
        onClick: () => emit("openCreateTaskModal"),
    },
    {
        icon: BellIcon,
        onClick: () => emit("openNotificationSidebar"),
    },
]

const currentUser = computed(() => authStore.currentUser)

const userNavigation = computed(() => {
    const baseNavigation = [
        { name: "My Settings", icon: UserIcon, onClick: navigateToMySettings },
        { name: "Agency Settings", icon: OfficeBuildingIcon, onClick: navigateToSettings },
        { name: "Plans & Billing", icon: CreditCardIcon, onClick: navigateToBilling },
        // { name: "Product Changes", icon: ViewGridIcon, onClick: undefined },
        // { name: "System Status", icon: InformationCircleIcon, onClick: undefined },
        { name: "Log Out", icon: LogoutIcon, onClick: logout },
    ]

    // Filter out Agency Settings and Plans & Billing for member role
    if (currentUser.value?.role?.name === AuthUserRole.member) {
        return baseNavigation.filter((item) => !["Agency Settings", "Plans & Billing"].includes(item.name))
    }

    return baseNavigation
})

async function navigateToSettings() {
    navigationSidebarStore.toggleSidebar(false)
    await router.push({ name: "agencySettings" })
}

async function navigateToBilling() {
    navigationSidebarStore.toggleSidebar(false)
    await router.push({ name: "billing" })
}

async function navigateToMySettings() {
    navigationSidebarStore.toggleSidebar(false)
    await router.push({ name: "mySettings" })
}

async function logout() {
    setIsLoggingOut(true)

    if (workflowStore.hasUnsavedChanges || formStore.hasUnsavedChanges) {
        await router.push({ name: "login" })
        setIsLoggingOut(false)
        return
    }

    await authStore.logout()
    clearStorage()
    authStore.currentUser = {} as User
    setColorShades("--primary-color")
    setColorShades("--link-color")
    socketStore.disconnectSocket()

    await router.push({ name: "login" })

    mainStore.resetAll()
    setIsLoggingOut(false) // Reset after clean logout
    await agencyThemeStore.getAgencyThemeBySubdomain()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuActionItems, (item, index) => {
      return _createElementVNode("div", { key: index }, [
        _createVNode(GgmsButton, {
          styleType: "simple",
          isMenuActionItems: true,
          classes: ['rounded-full w-10 h-10 px-0 py-0'],
          onClick: item.onClick
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "h-6 w-6 text-gray-400" }))
          ]),
          _: 2
        }, 1032, ["onClick"])
      ])
    }), 64)),
    _createVNode(_unref(Menu), {
      as: "div",
      class: "relative z-50"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MenuButton), { class: "max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color-500" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (currentUser.value?.profilePicture?.url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: currentUser.value.profilePicture.url,
                    class: "h-8 w-8 rounded-full object-cover",
                    alt: "profile-photo"
                  }, null, 8, _hoisted_3))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(getInitials)(currentUser.value?.fullName || "X Y")), 1))
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MenuItems), { class: "origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userNavigation.value, (item) => {
                  return (_openBlock(), _createBlock(_unref(MenuItem), {
                    key: item.name
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "block px-4 py-2 text-sm text-gray-700 border-b last:border-b-0 cursor-pointer hover:bg-gray-100",
                        onClick: item.onClick
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "h-5 w-5 text-gray-400" })),
                          _createElementVNode("p", null, _toDisplayString(item.name), 1)
                        ])
                      ], 8, _hoisted_5)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})